import React from 'react';
import { Box, Container, Typography, useTheme } from '@mui/material';
import { content } from '../../data/content';

const Footer: React.FC = () => {
  const theme = useTheme();
  const { copyright } = content.footer;

  return (
    <Box
      component="footer"
      sx={{
        bgcolor:  'background.default',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Gradient top border */}
      <Box sx={{
        position:   'absolute',
        top:        0,
        left:       0,
        right:      0,
        height:     '1px',
        background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}55, #a78bfa55, transparent)`,
      }} />

      {/* Subtle top glow */}
      <Box sx={{
        position:      'absolute',
        top:           '-60%',
        left:          '50%',
        transform:     'translateX(-50%)',
        width:         '60%',
        paddingBottom: '20%',
        borderRadius:  '50%',
        background:    `radial-gradient(ellipse, ${theme.palette.primary.main}08 0%, transparent 70%)`,
        pointerEvents: 'none',
      }} />

      <Container maxWidth="lg" sx={{ py: 4, position: 'relative', zIndex: 1 }}>
        {/* Copyright row */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
          <Typography
            variant="caption"
            sx={{
              color:      'text.secondary',
              fontFamily: '"JetBrains Mono", monospace',
              fontSize:   '0.6875rem',
              opacity:    0.6,
            }}
          >
            {copyright}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color:      'text.secondary',
              fontFamily: '"JetBrains Mono", monospace',
              fontSize:   '0.6875rem',
              opacity:    0.4,
            }}
          >
            · Built with React & MUI
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
